/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Region {
  AUSTIN = 'austin',
  SAN_ANTONIO = 'san_antonio',
  HOUSTON = 'houston',
  DALLAS = 'dallas',
  FORT_WORTH = 'fort_worth',
  WEST_TEXAS = 'west_texas',
}
